// «Возражения» — все возражения клиентов по потоку разговоров (#846).
// Вход — из карточки возражений во вкладке Quality; фильтр карточки
// (период, проекты) приходит параметрами адреса.
import { useCallback } from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { MessageSquareWarning } from 'lucide-react';
import { DashboardBody } from '@/components/layout/DashboardBody';
import { Breadcrumb, BreadcrumbItem } from '@/components/navigation/breadcrumb';
import { useDocumentTitle } from '@/hooks/useDocumentTitle';
import { ObjectionsView } from '@/components/analytics/objections/ObjectionsView';
import {
  parseObjectionsSearch,
  type ObjectionsSearch,
} from '@/components/analytics/objections/objections-search';

function ObjectionsPage() {
  const { t } = useTranslation('dashboard');
  useDocumentTitle(t('objectionsPage.title'));
  const search = Route.useSearch();
  const navigate = Route.useNavigate();
  const onSearchChange = useCallback(
    (patch: Partial<ObjectionsSearch>) =>
      void navigate({ search: (previous) => ({ ...previous, ...patch }), replace: true }),
    [navigate]
  );

  return (
    <DashboardBody
      title={t('objectionsPage.title')}
      subtitle={t('objectionsPage.subtitle')}
      icon={MessageSquareWarning}
      breadcrumbs={
        <Breadcrumb>
          <BreadcrumbItem href="/">Aelo</BreadcrumbItem>
          <BreadcrumbItem href="/dashboard">
            {t('objectionsPage.breadcrumbParent')}
          </BreadcrumbItem>
          <BreadcrumbItem current>{t('objectionsPage.title')}</BreadcrumbItem>
        </Breadcrumb>
      }
    >
      <ObjectionsView search={search} onSearchChange={onSearchChange} />
    </DashboardBody>
  );
}

export const Route = createFileRoute('/analytics/objections')({
  component: ObjectionsPage,
  validateSearch: (search: Record<string, unknown>): ObjectionsSearch =>
    parseObjectionsSearch(search),
});
